import { useMutation } from '@apollo/client';

import { UpdateUserValidatedInput } from '../../apollo/__generated__/graphql';
import { UPDATE_USER_VALIDATED } from '../graphql/mutation/updateUserValidatedMutation.graphql';

export const useUpdateUserValidatedMutation = () => {
  const [mutate] = useMutation(UPDATE_USER_VALIDATED, { onError: () => null });

  const updateUserValidated = (
    updateUserValidatedInput: UpdateUserValidatedInput,
  ) => {
    mutate({
      variables: {
        updateUserValidatedInput,
        eventId: updateUserValidatedInput.eventId,
      },
    });
  };

  return { updateUserValidated };
};
